import {createContext, useContext, useEffect, useState} from "react";
import {SettingApi} from "../utils/SettingApi";

const SettingContext = createContext(null);
const SettingProvider = ({children}) => {
    const [state, setState] = useState({
        "home": {
            "videoBanner": {
                "video": null,
                "title": "",
                "description": "",
                "hasButton1": false,
                "hasButton2": false,
                "Button1Text": "",
                "Button2Text": ""
            },
            "lastNewTitle": "",
            "imageBanner": {
                "img": "",
                "title": ""
            },
            "benefit": {
                "title": "",
                "video": ""
            },
            "customersTitle": "",
            "newsTitle": ""
        },
        "aboutUs": {
            "videoBanner": {
                "video": "",
                "title": "",
                "description": "",
                "hasButton1": true,
                "hasButton2": true,
                "Button1Text": "",
                "Button2Text": ""
            },
            "embeddedVideo": {
                "video": "",
                "title": "",
                "description": ""
            },
            "person": {
                "title": "",
                "slogan": ""
            },
            "manager": {
                "img": "",
                "message": "",
                "name": "",
                "position": ""
            },
            "infoBanner": {
                "img": "",
                "record": [
                    {
                        "name": "customers",
                        "amount": ""
                    },
                    {
                        "name": "customers",
                        "amount": ""
                    },
                    {
                        "name": "customers",
                        "amount": ""
                    },
                    {
                        "name": "customers",
                        "amount": ""
                    }
                ],
                "benefit": [
                    {
                        "title": "",
                        "description": ""
                    },
                    {
                        "title": "",
                        "description": ""
                    },
                    {
                        "title": "",
                        "description": ""
                    }
                ]
            }
        },
        "footer": {
            "index": 0,
            "places": [],
            "mail": ""
        }
    });

    const fetchSetting = async () => {
        await SettingApi.getSetting((result) => {
            setState(result.data);
        }, (error) => {

        });
    }
    useEffect(() => {
        (async () => {
            await fetchSetting();
        })();
    }, []);

    return (
        <SettingContext.Provider value={{state}}>
            {children}
        </SettingContext.Provider>
    )
}
const useSettingState = () => {
    const state = useContext(SettingContext).state;
    return {
        state
    }
}
export {SettingProvider, useSettingState, SettingContext};
